import React from 'react';
import { useNavigate } from 'react-router-dom';

const UserProfileIndicator = ({ user }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/student-dashboard');
  };

  const getInitials = (name) => {
    if (!name) return 'U';
    const parts = name?.trim()?.split(' ');
    if (parts?.length === 1) return parts?.[0]?.charAt(0)?.toUpperCase();
    return (parts?.[0]?.charAt(0) + parts?.[parts?.length - 1]?.charAt(0))?.toUpperCase();
  };

  const initials = user?.initials || getInitials(user?.name);

  return (
    <div
      className="user-profile-indicator"
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e?.key === 'Enter' || e?.key === ' ') {
          e?.preventDefault();
          handleClick();
        }
      }}
      aria-label={`Profil de ${user?.name || 'utilisateur'}`}
    >
      <div className="user-profile-avatar">
        {initials}
      </div>
      <div className="user-profile-info">
        <div className="user-profile-name">{user?.name || 'Utilisateur'}</div>
        <div className="user-profile-level">{user?.level || 'Niveau 1'}</div>
      </div>
    </div>
  );
};

export default UserProfileIndicator;